import React from "react";
import PropTypes from "prop-types";
import MessagesBalloon from "./messagesBalloon.jsx";
import ListStyles from "./messagesList.module.css";

const MessagesList = ({ data }) => {
  return (
    <>
      <div className={ListStyles.container}>
        <div className={ListStyles.separation}>&nbsp;</div>
        {data.map((message) => (
          <MessagesBalloon
            key={message.id}
            author={message.author}
            time={message.time}
            message={message.message}
          />
        ))}
      </div>
    </>
  );
};

MessagesList.propTypes = {
  data: PropTypes.array.isRequired,
};

export default MessagesList;
